<template>
  <modal-padrao
    ref="modal-porta-serial"
    :max-width="EhTelaPequena ? '90%' : '50%'"
    :titulo-ok="tituloOk"
    @ok="conectar"
  >
    <template #titulo>
      <span>
        {{ $t('modulos.calibracao.valores.titulos.porta_serial') }}
      </span>
      <span v-if="port">
        [{{ $t('geral.botoes.ativo').toUpperCase() }}]
      </span>
      <div
        v-if="port"
        class="blinking-light"
      />
    </template>
    <div
      style="min-height: 200px"
      class="mt-2"
    >
      <v-form class="row mb-2">
        <input-text
          v-model="baudRate"
          class="col-6"
          label="BaudRate"
          type="number"
        />
        <input-text
          v-model="dataBits"
          class="col-6"
          label="Data Bits"
          type="number"
        />
        <input-text
          v-model="parity"
          class="col-6"
          label="Parity"
        />
        <input-text
          v-model="stopBits"
          class="col-6"
          label="StopBits"
          type="number"
        />
      </v-form>
    </div>
  </modal-padrao>
</template>
<script>
export default {
  data() {
    return {
      baudRate: 4800,
      dataBits: 7,
      parity: this.parity || 'none',
      stopBits: 2,
      port: null,
      reader: null,
      controller_aborter: new AbortController(),
    };
  },
  computed: {
    EhTelaPequena() {
      return ['sm', 'xs'].includes(this.$vuetify.breakpoint.name);
    },
    tituloOk() {
      return !this.port ? this.$t('geral.botoes.conectar') : this.$t('geral.botoes.encerrar');
    },
  },
  methods: {
    abrirModal: function () {
      this.$refs['modal-porta-serial'].abrirModal();
    },
    fecharModal() {
      this.$refs['modal-porta-serial'].fecharModal();
    },
    conectar() {
      if(this.port){
        this.fecharConexao()
        return this.fecharModal();
      }

      this.abrirPorta().then(() => {
        this.toastSucesso('Conectado com sucesso!');
        this.iniciarLeitura();
        this.fecharModal();
      });
    },
    fecharPorta(){
      this.port?.close().then(() => {
        setTimeout(() => this.toastAlerta('Conexão com o instrumento encerrada!'), 500)
        this.port = null;
      })
    },
    async iniciarLeitura() {
      const decoder = new window.TextDecoderStream();
      this.controller_aborter = new AbortController();
      this.port.readable.pipeTo(decoder.writable, { signal: this.controller_aborter.signal })
        .catch(() => {
          this.controller_aborter.signal.aborted && this.fecharPorta();
        })
      const inputStream = decoder.readable;
      this.reader = inputStream.getReader();
      try {
        //eslint-disable-next-line
        while (true) {
          const { value, done } = await this.reader.read();
          if (done) window.alert('A leitura do equipamento foi encerrada!');
          if (done) break;

          if(value.length == 1 && value != '0')
            continue;
            
          this.$emit('porta-serial', value);
        }
      } catch (error) {
        console.warn(error)
        this.reader.releaseLock();
        this.reader = null;
        !this.controller_aborter.signal.aborted && setTimeout(this.iniciarLeitura, 100);
      }
    },
    async abrirPorta() {
      if (this.port) return;
      const port = await navigator.serial.requestPort();

      await port.open({
        baudRate: Number(this.baudRate),
        dataBits: Number(this.dataBits),
        parity: this.parity,
        stopBits: Number(this.stopBits),
      });

      this.port = port;
      return;
    },
    fecharConexao(){
      this.controller_aborter.abort()
    },
  },
};
</script>
<style>
.blinking-light {
    margin-left: 10px;
    width: 8px;
    height: 8px;
    background-color: rgb(76, 168, 107);
    border-radius: 50%;
    animation: blinklightanim 1s infinite;
    display: inline-block;
    margin-bottom: 3px;
  }

  @keyframes blinklightanim {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
</style>
